var $7b2b43dc5eacdef4$exports = {};
$7b2b43dc5eacdef4$exports = {
    "info": `\u{4FE1}\u{606F}`,
    "negative": `\u{9519}\u{8BEF}`,
    "positive": `\u{6210}\u{529F}`
};


export {$7b2b43dc5eacdef4$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
